<div #chartElem [id]="id"></div>
